import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UpdateDossierScreenConfigController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierScreenConfigController.php
* @route '/api/dossier/{dossier}/screen-config'
*/
const UpdateDossierScreenConfigController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierScreenConfigController.url(args, options),
    method: 'put',
})

UpdateDossierScreenConfigController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/screen-config',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierScreenConfigController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierScreenConfigController.php
* @route '/api/dossier/{dossier}/screen-config'
*/
UpdateDossierScreenConfigController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateDossierScreenConfigController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierScreenConfigController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierScreenConfigController.php
* @route '/api/dossier/{dossier}/screen-config'
*/
UpdateDossierScreenConfigController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierScreenConfigController.url(args, options),
    method: 'put',
})

export default UpdateDossierScreenConfigController